import * as angular from 'angular';

"use strict";

angular.module('UsersModule', [])

export default 'UsersModule';